import { provideRouter, withRouterConfig } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.routes';
import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  importProvidersFrom,
  provideZoneChangeDetection,
  provideAppInitializer,
} from '@angular/core';
import { AccessControlService } from './services/access-control.service';
import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation,
  LogLevel,
} from '@azure/msal-browser';
import {
  MsalInterceptor,
  MSAL_INSTANCE,
  MsalInterceptorConfiguration,
  MsalGuardConfiguration,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG,
  MsalService,
  MsalGuard,
  MsalBroadcastService,
} from '@azure/msal-angular';

import {
  DEFAULT_INTERRUPTSOURCES,
  Idle,
  IdleExpiry,
  SimpleExpiry,
} from '@ng-idle/core';
import { GlobalErrorHandler } from '@services/global-error-handler.service';
import { environment } from 'src/environments/environment';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { httpLoaderInterceptor } from './interceptors/http-loader.interceptor';

// export function HttpLoaderFactory(http: HttpClient) {
//   return new TranslateHttpLoader(http, './assets/i18n/', '.json');
// }
export function loggerCallback(logLevel: LogLevel, message: string) {}
export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.msalConfig.auth.authority,
      redirectUri: environment.msalConfig.auth.redirectUri,
      postLogoutRedirectUri: '/',
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
    },
    system: {
      allowPlatformBroker: false, // Disables WAM Broker
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(
    environment.msalConfig.auth.uri,
    environment.msalConfig.auth.scopes,
  );
  protectedResourceMap.set(
    environment.msalConfig.auth.appUrl,
    environment.msalConfig.auth.apiscopes,
  );
  protectedResourceMap.set(
    'https://graph.microsoft.com/v1.0/users',
    environment.msalConfig.auth.scopes,
  );

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
    strictMatching: false,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...environment.msalConfig.auth.scopes],
    },
    // loginFailedRoute: '/login-failed',
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })),

    // provideHttpClient(withInterceptors([httpLoaderInterceptor])),
    // ...TranslateModule.forRoot({
    //   loader: {
    //     provide: TranslateLoader,
    //     useFactory: HttpLoaderFactory,
    //     deps: [HttpClient],
    //   },
    // }).providers,
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(BrowserModule),
    provideHttpClient(
      withInterceptors([httpLoaderInterceptor]),
      withInterceptorsFromDi(),
      withFetch(),
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },

    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    Idle, // Idle service
    {
      provide: 'IDLE_CONFIG',
      useValue: {
        idle: environment.timeoutValues.IDLE_TIME_INSECONDS,
        timeout: environment.timeoutValues.IDLE_TIMEOUT_INSECONDS,
      },
    }, // Idle config
    { provide: IdleExpiry, useClass: SimpleExpiry }, // Provide SimpleExpiry
    { provide: ErrorHandler, useClass: GlobalErrorHandler },

    MsalService,
    MsalGuard,
    MsalBroadcastService,
    // Ensure access rules are loaded before app bootstrap
    provideAppInitializer(() => inject(AccessControlService).init()),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json',
      }),
      fallbackLang: 'en',
      lang: 'en',
    }),
  ],
};
